import { useEffect, useState } from "react";
import styled from "styled-components";
import { INITPAGING } from "../based/Constants";
import TableFooter from "../based/content/TableFooter";
import CommonModal from "../based/refactor/CommonModal";
import PushingServices from "../based/services/PushingServices";

function SelectDesignModal({ show, onClose, onSave, listCheckedDesignProduct = [] }) {
    const [busy, setBusy] = useState(false);
    const [pagingModel, setPagingModel] = useState({ ...INITPAGING });
    const [lstModel, setLstModel] = useState([]);

    console.log("lstModel", lstModel);

    useEffect(() => {
        if (show) {
            getDatas({ ...pagingModel });
        }
    }, [show]);

    const getDatas = async (page) => {
        setBusy(true);
        const [err, data] = await PushingServices.GetPushingProductTotalModels({ ...page, status: -1 });
        if (!err && data) {
            let listObjects = data.listObjects || [];
            if (listCheckedDesignProduct && listCheckedDesignProduct.length > 0) {
                //đánh dấu các sản phẩm đã chọn
                listObjects = listObjects.map((item) => {
                    const isSelected = listCheckedDesignProduct.some((checkedItem) => checkedItem.designId === item.designId);
                    return { ...item, isSelected };
                });
            }

            setLstModel(listObjects);
            setPagingModel(data.paging);
        } else {
            setLstModel([]);
            setPagingModel(page);
        }
        setBusy(false);
    };

    return (
        <CommonModal
            onClose={onClose}
            isBusy={busy}
            busyMsg={"Đang tải"}
            size="lg"
            show={show}
            title={`Chọn sản phẩm muốn đồng bộ`}
            onConfirm={() => {
                //lấy danh sách sản phẩm đã chọn
                const selectedItems = lstModel.filter((item) => item.isSelected);
                if (selectedItems.length > 0) {
                    onSave(selectedItems);
                }
            }}
        >
            <Wrapper>
                <div className="filter-area">
                    <div className="search-area">
                        <input
                            type="text"
                            value={pagingModel.keyword}
                            placeholder="Tìm kiếm theo tên sản phẩm"
                            onChange={(e) => {
                                setPagingModel({ ...pagingModel, keyword: e.target.value });
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    getDatas({ ...pagingModel, pageNumber: 1 });
                                }
                            }}
                        />
                        <div
                            className="search-button cursor-pointer"
                            onClick={(e) => {
                                getDatas({ ...pagingModel, pageNumber: 1 });
                            }}
                        >
                            <i className="fa fa-search"></i>
                        </div>
                    </div>
                </div>
                <div className="list-item">
                    {lstModel.map((item, index) => {
                        let imageUrl = item.thumbnail;
                        if (imageUrl) {
                            imageUrl = imageUrl.replace(".jpg", "_crop.webp");
                        }
                        return (
                            <div
                                className={`item ${item.isSelected ? "selected" : ""} cursor-pointer`}
                                key={index}
                                onClick={(e) => {
                                    let lst = [...lstModel];
                                    let currentItem = lst[index];
                                    currentItem.isSelected = !currentItem.isSelected;
                                    setLstModel(lst);
                                }}
                            >
                                <div className="item-img">
                                    <img src={imageUrl} alt="" />
                                </div>
                                <div className="item-name">
                                    <span>{item.name}</span>
                                </div>
                                {item.isSelected && <span className="selected-badge">Đang chọn</span>}
                            </div>
                        );
                    })}
                </div>
                <TableFooter
                    paging={pagingModel}
                    itemToDisplay={20}
                    onFilter={(page) => {
                        getDatas(page);
                    }}
                />
            </Wrapper>
        </CommonModal>
    );
}

export default SelectDesignModal;

const Wrapper = styled.div`
    .search-area {
        display: flex;
        align-items: center;
        border: 1px solid #d9d9d9;
        background: #fff;
        width: 25%;
        padding: 10px;
    }

    .search-area input {
        border: none;
        width: 100%;
    }

    .search-button.cursor-pointer {
        margin-left: auto;
    }
    .item-img {
        width: 100%;
        aspect-ratio: 1;
    }
    .item.selected {
        border: 1px solid #d9d9d9;
        opacity: 0.9;
        background: #ffe3c0;
        position: relative;
    }

    span.selected-badge {
        position: absolute;
        top: 0;
        left: 0;
        background: #febd6a;
        padding: 5px 10px;
        overflow: hidden;
        color: #000;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .list-item {
        display: flex;
        flex-wrap: wrap;
    }

    .item-img {
        padding: 4px;
    }

    .item-img img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .item {
        width: 170px;
        margin: 10px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .item-name {
        color: #000;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 4px 10px;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .item-color {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        padding: 4px 10px;
    }

    .item-count {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        padding: 4px 10px;
    }
`;
